import { render, staticRenderFns } from "./DocumentButtonsGroup.vue?vue&type=template&id=7ef66eeb&scoped=true"
import script from "./DocumentButtonsGroup.vue?vue&type=script&lang=js"
export * from "./DocumentButtonsGroup.vue?vue&type=script&lang=js"
import style0 from "./DocumentButtonsGroup.vue?vue&type=style&index=0&id=7ef66eeb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef66eeb",
  null
  
)

export default component.exports